import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import type { CreateRenewalFormState } from '../types';

export const useCreateRenewalForm = (defaultName: string = '') => {
  const { control, handleSubmit, watch, setValue } = useForm<CreateRenewalFormState>({
    defaultValues: {
      name: defaultName,
    },
  });

  const formValues = watch();

  useEffect(() => {
    if (!formValues.type) {
      return;
    }

    if (formValues.type === 'replicate') {
      setValue('skipPreviouslyRemovedBlocks', false);
      setValue('keepPreviouslyAddedBlocks', false);
      setValue('baseTemplateId', undefined);
    } else if (formValues.type === 'refresh') {
      // baseTemplateId should be set by the controller when appropriate
      return;
    } else {
      setValue('baseTemplateId', undefined);
    }
  }, [formValues.type, setValue]);

  return {
    control,
    formValues,
    handleSubmit,
    setValue,
  };
};
